/* global axios */

const API_VERSION = 'v2';

class SalesDashboardAPI {
  constructor() {
    this.apiVersion = `/api/${API_VERSION}`;
  }

  // eslint-disable-next-line class-methods-use-this
  get accountIdFromRoute() {
    const isInsideAccountScopedURLs =
      window.location.pathname.includes('/app/accounts');
    if (isInsideAccountScopedURLs) {
      return window.location.pathname.split('/')[3];
    }
    return '';
  }

  get baseUrl() {
    return `${this.apiVersion}/accounts/${this.accountIdFromRoute}/sales_dashboard`;
  }

  // Buscar KPIs gerais
  getSummary(params = {}) {
    return axios.get(`${this.baseUrl}/summary`, { params });
  }

  // Buscar valor do pipeline por estágio e funil
  getPipelineValue(params = {}) {
    return axios.get(`${this.baseUrl}/pipeline_value`, { params });
  }

  // Buscar previsão de receita
  getRevenueForecast(params = {}) {
    return axios.get(`${this.baseUrl}/revenue_forecast`, { params });
  }

  // Buscar métricas de conversão
  getConversionMetrics(params = {}) {
    return axios.get(`${this.baseUrl}/conversion_metrics`, { params });
  }

  // Buscar performance por agente
  getAgentPerformance(params = {}) {
    return axios.get(`${this.baseUrl}/agent_performance`, { params });
  }

  // Buscar ranking de empresas
  getCompanyLeaderboard(params = {}) {
    return axios.get(`${this.baseUrl}/company_leaderboard`, { params });
  }

  // Método para buscar todos os dados do dashboard de uma vez
  async getDashboardData(params = {}) {
    const [
      summary,
      pipelineValue,
      revenueForecast,
      conversionMetrics,
      agentPerformance,
      companyLeaderboard,
    ] = await Promise.all([
      this.getSummary(params),
      this.getPipelineValue(params),
      this.getRevenueForecast(params),
      this.getConversionMetrics(params),
      this.getAgentPerformance(params),
      this.getCompanyLeaderboard(params),
    ]);

    return {
      summary: summary.data,
      pipelineValue: pipelineValue.data,
      revenueForecast: revenueForecast.data,
      conversionMetrics: conversionMetrics.data,
      agentPerformance: agentPerformance.data,
      companyLeaderboard: companyLeaderboard.data,
    };
  }
}

export default new SalesDashboardAPI();
